import { getAllActions } from '../../api/UserManagement/getAllActions.api';
import { getAllProjects } from '../../api/UserManagement/getAllProjects.api';
import {
	getAllRolesByProjectCode,
	getAllRoles,
} from '../../api/UserManagement/getAllRoles.api';
import { getAllUsers } from '../../api/UserManagement/getAllUsers.api';
import { getProjectList } from '../../api/UserManagement/getProjectList.api';
import { getUserById } from '../../api/UserManagement/getUserById.api';
import getRolesAccessibilitiesAPI from '../../api/UserManagement/getRolesAccessibilities.api';
import {
	GET_ALL_ACCESSIBILITIES_FAIL,
	GET_ALL_ACCESSIBILITIES_SUCCESS,
	GET_CLICKED_USER_FAIL,
	GET_CLICKED_USER_SUCCESS,
	GET_PROJECTS_FAIL,
	GET_PROJECTS_SUCCESS,
	GET_PROJECT_LIST_BY_ID_FAIL,
	GET_PROJECT_LIST_BY_ID_SUCCESS,
	GET_ROLES_FAIL,
	GET_ROLES_SUCCESS,
	GET_USERS_FAIL,
	GET_USERS_SUCCESS,
	GET_USER_BY_ID_FAIL,
	GET_USER_BY_ID_SUCCESS,
	GET_ROLES_ACCESSIBILITIES_SUCCESS,
	GET_ROLES_ACCESSIBILITIES_FAIL,
	GET_ACCESSIBILITIES_BY_ROLE_SUCCESS,
	GET_ACCESSIBILITIES_BY_ROLE_FAIL,
	SAVE_USER_ACCESSIBILITY_SUCCESS,
	SAVE_USER_ACCESSIBILITY_FAIL,
	GET_ARCHIVED_USERS_SUCCESS,
	GET_ARCHIVED_USERS_FAIL,
	GET_ROLES_ALL_PROJECTS_SUCCESS,
	GET_ROLES_ALL_PROJECTS_FAIL,
	SET_PROJECT_SELECTED_CODE,
	CLEAR_USER_BY_ID,
} from './types';
import { getDefaultAccessibility } from '../../api/UserManagement/getDefaultAccessibility.api';
import { saveAccessibility } from '../../api/UserManagement/saveAccessibility.api';
import { getAllArchivedUsers } from '../../api/UserManagement/getAllArchivedUsers.api';

export const getUsers = (id) => {
	return async (dispatch) => {
		try {
			getAllUsers((data) => {
				console.log('getAllUsers data', data);
				dispatch(getUsersSuccess(data));
			});
		} catch (error) {
			dispatch(getUsersFail(error));
		}
	};
};

export const getCompanies = () => {
	return async (dispatch) => {
		try {
			getAllProjects((data) => {
				dispatch(getProjectsSuccess(data));
			});
		} catch (error) {
			dispatch(getProjectsFail(error));
		}
	};
};

export const getClickedUser = (id) => {
	return async (dispatch) => {
		try {
			var data = id;

			dispatch(getClickedUserSuccess(data));
		} catch (error) {
			dispatch(getClickedUserFail(error));
		}
	};
};

export const getRoles = (projectId) => {
	return async (dispatch) => {
		try {
			getAllRolesByProjectCode(projectId, (data) => {
				dispatch(getRolesSuccess(data));
			});
		} catch (error) {
			dispatch(getRolesFail(error));
		}
	};
};

export const getRolesOfAllProjects = () => {
	return async (dispatch) => {
		try {
			getAllRoles((data) => {
				dispatch(getRolesOfAllProjectsSuccess(data));
			});
		} catch (error) {
			dispatch(getRolesOfAllProjectsFail());
		}
	};
};

export const getRolesAccessibilities = () => {
	return async (dispatch) => {
		try {
			getRolesAccessibilitiesAPI((data) => {
				dispatch(getRolesAccessibilitiesSuccess(data));
			});
		} catch (error) {
			dispatch(getRolesAccessibilitiesFail());
		}
	};
};

export const getUserByUserId = (id) => {
	return async (dispatch) => {
		try {
			getUserById(id, (data) => {
				console.log('getUserByUserId data', data);

				dispatch(getUserByIdSuccess(data));
			});
		} catch (error) {
			dispatch(getUserByIdFail(error));
		}
	};
};

export const getAllAccessibilities = () => {
	return async (dispatch) => {
		try {
			getAllActions((data) => {
				dispatch(getAllAccessibilitiesSuccess(data));
			});
		} catch (error) {
			dispatch(getAllAccessibilitiesFail(error));
		}
	};
};

export const getProjectListById = (userId) => {
	return async (dispatch) => {
		try {
			getProjectList(userId, (data) => {
				dispatch(getProjectListByIdSuccess(data));
			});
		} catch (error) {
			dispatch(getProjectListByIdFail(error));
		}
	};
};

export const getAccessibilitiesByRoles = (projectCode, roleId) => {
	return async (dispatch) => {
		try {
			getDefaultAccessibility(projectCode, roleId, (data) => {
				dispatch(getAccessibilitiesByRolesSuccess(data));
			});
		} catch (error) {
			dispatch(getAccessibilitiesByRolesFail(error));
		}
	};
};

export const getArchivedUsers = (projectId) => {
	return async (dispatch) => {
		try {
			getAllArchivedUsers((data) => {
				dispatch(getArchivedUsersSuccess(data));
			});
		} catch (error) {
			dispatch(getArchivedUsersFail(error));
		}
	};
};

export const getAccessibilitiesByRolesSuccess = (payload) => ({
	type: GET_ACCESSIBILITIES_BY_ROLE_SUCCESS,
	payload,
});

export const getAccessibilitiesByRolesFail = (payload) => ({
	type: GET_ACCESSIBILITIES_BY_ROLE_FAIL,
	payload,
});

export const getProjectListByIdSuccess = (payload) => ({
	type: GET_PROJECT_LIST_BY_ID_SUCCESS,
	payload,
});

export const getProjectListByIdFail = (payload) => ({
	type: GET_PROJECT_LIST_BY_ID_FAIL,
	payload,
});

export const getAllAccessibilitiesSuccess = (payload) => ({
	type: GET_ALL_ACCESSIBILITIES_SUCCESS,
	payload,
});

export const getAllAccessibilitiesFail = (payload) => ({
	type: GET_ALL_ACCESSIBILITIES_FAIL,
	payload,
});

export const getUserByIdSuccess = (payload) => ({
	type: GET_USER_BY_ID_SUCCESS,
	payload,
});

export const getUserByIdFail = (payload) => ({
	type: GET_USER_BY_ID_FAIL,
	payload,
});

export const getUsersSuccess = (payload) => ({
	type: GET_USERS_SUCCESS,
	payload,
});
export const getUsersFail = (payload) => ({
	type: GET_USERS_FAIL,
	payload,
});

export const getProjectsSuccess = (payload) => ({
	type: GET_PROJECTS_SUCCESS,
	payload,
});

export const getProjectsFail = (payload) => ({
	type: GET_PROJECTS_FAIL,
	payload,
});

export const getClickedUserSuccess = (payload) => ({
	type: GET_CLICKED_USER_SUCCESS,
	payload,
});

export const getClickedUserFail = (payload) => ({
	type: GET_CLICKED_USER_FAIL,
	payload,
});

export const getRolesSuccess = (payload) => ({
	type: GET_ROLES_SUCCESS,
	payload,
});

export const getRolesFail = (payload) => ({
	type: GET_ROLES_FAIL,
	payload,
});

export const getRolesAccessibilitiesSuccess = (payload) => ({
	type: GET_ROLES_ACCESSIBILITIES_SUCCESS,
	payload,
});

export const getRolesAccessibilitiesFail = () => ({
	type: GET_ROLES_ACCESSIBILITIES_FAIL,
});

export const getArchivedUsersSuccess = (payload) => ({
	type: GET_ARCHIVED_USERS_SUCCESS,
	payload,
});

export const getArchivedUsersFail = () => ({
	type: GET_ARCHIVED_USERS_FAIL,
});

export const getRolesOfAllProjectsSuccess = (payload) => ({
	type: GET_ROLES_ALL_PROJECTS_SUCCESS,
	payload,
});

export const getRolesOfAllProjectsFail = () => ({
	type: GET_ROLES_ALL_PROJECTS_FAIL,
});

export const setProjectSelectedCode = (payload) => ({
	type: SET_PROJECT_SELECTED_CODE,
	payload,
});

export const clearUserById = () => ({
	type: CLEAR_USER_BY_ID,
});
